import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../store-config';
import { SnackbarState } from './snackbar.slice';

const selectSnackbar = (state: RootState): SnackbarState => state.snackbarState;

export const selectSnackbarContent = createSelector([selectSnackbar], (snackbar) => snackbar.contents);
